import { render } from "./GestionEventosDirectos.vue?vue&type=template&id=393cd25b"
import script from "./GestionEventosDirectos.vue?vue&type=script&lang=js"
export * from "./GestionEventosDirectos.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0_supports-color@6.1.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__